import connection from "./connection";
import axios from 'axios';
import { MessageRequest, MessageResponse } from '../../../../shared-models/common-models/src/index';
export class WhatsAppNotificationService {
    URL = connection.DEPLOY_URL;
    
    async sendPersonalMessage(message: MessageRequest): Promise<MessageResponse> {
        return await axios.post(this.URL + '/sendPersonalMessage', message).then((res) => {
            return res.data;
        });
    }

    async sendGroupMessage(message: MessageRequest): Promise<MessageResponse> {
        return await axios.post(this.URL + '/sendGroupMessage', message).then((res) => {
            return res.data;
        });
    }
}